import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { routeMeta } from "../../seo/meta.mjs";

const setMeta = (attribute, key, content) => {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`);

  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.appendChild(element);
  }

  element.setAttribute("content", content);
};

const setCanonical = (href) => {
  let element = document.head.querySelector('link[rel="canonical"]');

  if (!element) {
    element = document.createElement("link");
    element.setAttribute("rel", "canonical");
    document.head.appendChild(element);
  }

  element.setAttribute("href", href);
};

const PageMeta = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const meta = routeMeta(pathname);

    document.title = meta.title;
    setMeta("name", "description", meta.description);
    setMeta("name", "robots", meta.robots);
    setMeta("name", "author", "UniverseDecoder");
    setMeta("name", "theme-color", meta.themeColor);
    setMeta("name", "color-scheme", "dark");
    setCanonical(meta.canonical);

    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", "UniverseDecoder");
    setMeta("property", "og:locale", "en_IN");
    setMeta("property", "og:title", meta.title);
    setMeta("property", "og:description", meta.description);
    setMeta("property", "og:url", meta.canonical);
    setMeta("property", "og:image", meta.image);
    setMeta("property", "og:image:secure_url", meta.image);
    setMeta("property", "og:image:type", "image/png");
    setMeta("property", "og:image:width", "1200");
    setMeta("property", "og:image:height", "630");
    setMeta("property", "og:image:alt", meta.imageAlt);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", meta.title);
    setMeta("name", "twitter:description", meta.description);
    setMeta("name", "twitter:image", meta.image);
    setMeta("name", "twitter:image:alt", meta.imageAlt);

    const favicon = document.getElementById("favicon");
    if (favicon) {
      favicon.href = `${meta.favicon}?v=3`;
    }

    let structuredData = document.getElementById("page-jsonld");
    if (!structuredData) {
      structuredData = document.createElement("script");
      structuredData.id = "page-jsonld";
      structuredData.type = "application/ld+json";
      document.head.appendChild(structuredData);
    }
    structuredData.textContent = JSON.stringify(meta.jsonLd);
  }, [pathname]);

  return null;
};

export default PageMeta;
